module.exports = __webpack_public_path__ + "static/media/dodgem(19).74362f9d.PNG";